import { createFileRoute } from "@tanstack/react-router"

import { StoredPurchaseOrdersTab } from "@/screens/WarehouseReceiving/subfeatures/Stored/components"

export const Route = createFileRoute("/app/warehouse-receiving/stored/$goodsReceiptId/_layout/purchase-orders")({
  component: StoredPurchaseOrdersTab,
})
